// Reactive recovery from stale-deploy chunk 404s: after a redeploy the hashed
// chunk filenames change, so a user on the old build 404s loading a lazy
// route/CSS ("Loading chunk X failed" / err.code "CSS_CHUNK_LOAD_FAILED").
// version-check.js is the proactive path (polls + prompts); this reloads once
// when a chunk fails before that poll catches it.

const RELOAD_TS_KEY = "pubrio:chunk-reload-ts";
const RELOAD_DEBOUNCE_MS = 10 * 1000;

export function isChunkLoadError(error) {
  if (!error) return false;
  const name = String(error.name || "");
  const code = String(error.code || "");
  const message = String(error.message || error);
  return (
    name === "ChunkLoadError" ||
    code === "CSS_CHUNK_LOAD_FAILED" ||
    /Loading (?:CSS )?chunk [^\s]+ failed/i.test(message)
  );
}

// Reload once; the timestamp guard stops a loop when the chunk is truly gone.
export function reloadOnceForChunkError(error) {
  if (!isChunkLoadError(error)) return false;

  let last = 0;
  try {
    last = Number(window.sessionStorage.getItem(RELOAD_TS_KEY)) || 0;
  } catch {
    // sessionStorage unavailable (private mode / sandboxed iframe)
  }

  if (Date.now() - last < RELOAD_DEBOUNCE_MS) return false;

  try {
    window.sessionStorage.setItem(RELOAD_TS_KEY, String(Date.now()));
  } catch {
    // ignore
  }

  window.location.reload();
  return true;
}

// Router-navigation + global async paths. The Vue component path lives in
// main.js so it can be set before Sentry.init chains onto it.
export function installChunkReloadHandlers(router) {
  if (router && typeof router.onError === "function") {
    router.onError((error) => {
      reloadOnceForChunkError(error);
    });
  }

  window.addEventListener("error", (event) => {
    reloadOnceForChunkError(event && event.error);
  });

  window.addEventListener("unhandledrejection", (event) => {
    reloadOnceForChunkError(event && event.reason);
  });
}
